import { ActivityDto, AuditActivityDto, AuditInfoRequest } from '../dtos/activity.dto';
import { ActivityCriteria, ActivityLogDownloadInfo, TimeDetails } from '../dtos/search-criteria.dto';
import { getStartAndEndDate } from './datesUtils';
import moment from 'moment';
import DOMPurify from 'dompurify';

export const convertResponseToActivity = (response: AuditActivityDto[]): ActivityDto[] => {
    return response.map((activity) => {
        return {
            auditTimestamp: moment(activity.auditTimestamp)
                .format('MMM D YYYY \u2022 HH:mm:ss'),
            activity: activity.activity,
            policyVersion: activity.policyVersion ? `V${activity.policyVersion?.toString()}` : '',
            updatedBy: activity.updatedBySource === 'ATT' ? 'AT&T' : activity.updatedBy,
            clientIp: activity.clientIp,
            updatedBySource: activity.updatedBySource
        };
    });
};

export const convertCriteriaToRequest = (criteria: ActivityCriteria): AuditInfoRequest => {
    const { fromDateTime, toDateTime } = getTimeRange(criteria.timeDetails);

    return {
        timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
        auditFilterRequest: {
            fromDateTime: moment.utc(fromDateTime).format(),
            toDateTime: moment.utc(toDateTime).format(),
            activity: criteria.activity || [],
            policyVersion: criteria.policyVersion || [],
            user: criteria.user || '',
            clientIp: criteria.clientIp || ''
        }
    };
};

export const buildUrlParams = (sortBy: string, sortOrder: string) => ({
    ...(sortBy && { sortBy }),
    ...(sortOrder && { sortOrder }),
});


const getTimeRange = (timeDetails?: TimeDetails): { fromDateTime: Date; toDateTime: Date } => {
    let fromDateTime: Date;
    let toDateTime: Date;

    if (timeDetails?.timeRange === 'Custom' && timeDetails.startDate && timeDetails.endDate) {
        fromDateTime = timeDetails.startDate;
        toDateTime = timeDetails.endDate;
    } else {
        [fromDateTime, toDateTime] = getStartAndEndDate(timeDetails?.timeRange || '');
    }

    return { fromDateTime, toDateTime };
};

export const buildActivityDownloadParams = (exportMethod: string, searchCriteria: ActivityCriteria): ActivityLogDownloadInfo | null => {
    const { timeDetails, activity, policyVersion, user, clientIp } = searchCriteria;
    if (!timeDetails?.timeRange) return null;
    const { fromDateTime, toDateTime } = getTimeRange(timeDetails);

    return {
        logsFileType: exportMethod,
        timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
        auditFilterRequest: {
            fromDateTime: moment.utc(fromDateTime).toDate(),
            toDateTime: moment.utc(toDateTime).toDate(),
            activity: activity,
            policyVersion: policyVersion || [],
            user,
            clientIp
        }
    };
};

export const triggerFileDownload = (blob: Blob, filename: string) => {
    // Basic sanitization to remove angle brackets from filename
    const sanitizedFilename = filename.replace(/[<>]/g, '');
    const url = DOMPurify.sanitize(window.URL.createObjectURL(blob));
    const link = document.createElement('a');
    link.href = url;

    // Set the download attribute using the sanitized filename
    link.setAttribute('download', sanitizedFilename);

    document.body.appendChild(link);
    link.click();
    link.remove();
};